























import { Component, Mixins } from "vue-property-decorator";
import { HeaderPane } from "../../../base/components/panes";
import { TimeMeasure } from "../../../base/utilities";
import { DateDurationPicker } from "../../../base/components/system/selectors";
import { DateDuration } from "../../../base/domain/system";
import { DomainRegistry } from "../../domain";
import { IEditableFormatOperation } from "../../domain/editableFormat";
import { default as EditHistoryTableViewer } from "./viewers/EditHistoryTableViewer.vue";

@Component({
  components: {
    HeaderPane,
    DateDurationPicker,
    EditHistoryTableViewer,
  },
})
export default class EditHistoryView extends Mixins() {
  dateDuration: DateDuration = DateDuration.today();
  operations: IEditableFormatOperation[] = [];

  mounted(): void {
    this.loadEditHistory();
  }

  private async loadEditHistory(): Promise<void> {
    this.operations = [];
    await this.getEditHistory()
    .then(d => this.operations = d)
    .catch(e => {
      this.$error(
        "編集履歴取得失敗",
        "編集履歴を読み込めませんでした。",
        e
      );
    });
  }

  private getEditHistory(): Promise<IEditableFormatOperation[]> {
    return TimeMeasure.logAsync(
      "編集履歴取得",
      async () => {
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        return repository.getEditHistory({
          dateDuration: this.dateDuration.clone(),
        });
      },
      "",
      TimeMeasure.debug
    );
  }

  updateList(): void {
    this.loadEditHistory();
  }
}
